import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import * as allLangs from 'date-fns/locale';
import { useContext } from 'react';
import UserContext from '../../common/utils/getContext';
import Caption from './components/Caption/Caption';
import classNames from 'classnames';

export default function EventsCalendarWidget(props) {
    const { className, onSelect, onMonthChange, modifiers, modifiersClassNames, selected } = props;
    const { lang } = useContext(UserContext);

    return (
        <div>
            <DayPicker
                mode='single'
                className={classNames('eventsCalendarDefault', className)}
                locale={allLangs[lang]}
                components={{
                    Caption: Caption
                }}
                selected={selected}
                showOutsideDays
                onSelect={onSelect}
                onMonthChange={onMonthChange}
                modifiers={modifiers}
                modifiersClassNames={modifiersClassNames}
            />
        </div>
    );
}
